import styled from 'styled-components';
import { Button } from '@material-ui/core';

export const ButtonView = styled(Button)`
  height: 48px;
  display: flex;
  align-items: center;
  flex-direction: row;
  display: flex;
  margin-left: 20px;
  background-color: #333;
  border-radius: 30px;
  padding: 0px 16px 0px 10px;
  :hover {
    background-color: #333;
  }
`;
export const Strong = styled.strong`
  margin-left: 8px;
  font-family: 'Graphik-Regular';
  color: white;
  text-transform: initial;
`;
